
import XTable from 'vux/src/components/x-table/index.vue'

import { mapMutations } from "vuex";
export default {
name: "UmbilicalLine",
components: {
XTable,
},
data() {
return {
defaultJson: {
Weight: "体重",
"IV Fluids": "静脉补液",
"Correction factor": "校正因子",
},
form: {
weight: "",
},
UACresult: "--",
hasScore: false,
disabled: false,
};
},
created() {
this.hideLoad();
},
methods: {
...mapMutations(["hideLoad"]),
},
computed: {
/** 计算公式结果 */
score() {
let self = this;
let form = JSON.parse(JSON.stringify(self.form));
let flag = true;
for (const key in form) {
if (form.hasOwnProperty(key)) {
if (!form[key]) {
flag = false;
} else {
if (form[key] == "---") {
flag = false;
} else {
form[key] = Number(form[key]);
}
}
}
}
if (!flag) {
self.hasScore = false;
self.UACresult = "--";
return "--";
} else {


self.UACresult = 3 * form.weight + 9;
let result = (3 * form.weight + 9) / 2 + 1;

self.hasScore = true;
return String(result);
}
},
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Pedi/UmbilicalLine.vue